export const pillars = ['Decompression', 'Stability', 'Pelvic Alignment', 'Prevention'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'S.O.S. Rescue Protocol',
  desc: 'The immediate response to acute pain. This volume teaches you how to create a "Zero-Gravity" environment for your spine to stop the inflammatory cycle and breathe again.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Anti-Inflammatory Sleep Guide',
  desc: 'You spend a third of your life sleeping. Learn the exact pillow geometry and neuro-restoration protocols to stop damaging your back while you sleep.'
}, {
  n: 3,
  emoji: '📙',
  title: '7-Minute Morning Reset',
  desc: 'Eliminate morning stiffness before it starts. A fast, visual flow to "unlock" your vertebrae and prepare your body for the day ahead.'
}, {
  n: 4,
  emoji: '📕',
  title: 'The Pain-Free Chair System',
  desc: 'Transform your workstation into a recovery zone. Specific biomechanics for those who sit or stand for long hours, preventing disc compression.'
}, {
  n: 5,
  emoji: '📓',
  title: 'Pelvic & Hip Unlocker',
  desc: 'Address the root cause. If your hips are tight, your back pays the price. This volume restores the mobility your lumbar spine desperately needs to stay safe.'
}, {
  n: 6,
  emoji: '📔',
  title: 'The Iron Core Foundation',
  desc: 'Build a natural "corset" around your spine. Learn the McGill-inspired stability movements that shield your back from future injuries.'
}];
export const volumeIncludes = ['Step-by-step visual protocols', 'Pain severity assessment', 'Decompression checkpoints', 'Daily practice checklists', 'Printable tracking sheets', 'Home-based progressions'];
export const bonuses = [{
  n: '01',
  title: 'The Sciatica Emergency SOS Kit',
  desc: 'Specific high-level protocols to release the sciatic nerve and stop the radiation of pain down the leg.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/42kdDtgHdoks48jwVPJhyX/BONO_1.png'
}, {
  n: '02',
  title: 'The Pain-Free Workspace Blueprint',
  desc: 'A complete guide to ergonomic office setups, posture hacks, and micro-breaks for remote workers.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/i8ANhWzyKyRLtDmsszyMTA/BONO_2.png'
}, {
  n: '03',
  title: 'Morning Mobility Flow',
  desc: 'A visual guide to starting your day with fluid joints and zero tension.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/gTKWp3SD6REVUYcS1gRvzi/BONO_3.png'
}, {
  n: '04',
  title: 'The Anti-Inflammatory Kitchen',
  desc: 'Natural nutrition and supplement protocols to reduce systemic inflammation and speed up tissue repair.',
  price: '$22',
  cover: 'https://cdn.magicpatterns.com/uploads/bMysU5y3UQsApXLxqtyBgL/BONO_4.png'
}, {
  n: '05',
  title: 'The Shielded Daily Progress Tracker',
  desc: 'A professional log to track your pain levels, sleep quality, and daily wins to keep you motivated.',
  price: '$19',
  cover: 'https://cdn.magicpatterns.com/uploads/shFQpWxdgXBwbAvXB8qVSp/BONO_5.png'
}];
